const MAX_BADGE_COUNT = 99;

/** Caps a count badge at `99+` for display. */
export const formatBadgeCount = (count: number): number | string =>
  count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : count;
